import { render } from "./PartyLedger.vue?vue&type=template&id=475778be&scoped=true"
import script from "./PartyLedger.vue?vue&type=script&lang=js"
export * from "./PartyLedger.vue?vue&type=script&lang=js"

import "./PartyLedger.vue?vue&type=style&index=0&id=475778be&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475778be"]])

export default __exports__